import { graphql } from "@opensea/graphql"
import { CreateOrdersSummaryFragment } from "../../../../../components/CreateOrdersSummary/CreateOrdersSummary.fragment"
import { constructCollectionOffer_collectionFragment } from "../../utils/constructCollectionOffer.fragment"
import { CreateCollectionOfferFlowTableFragment } from "../CollectionOfferFlowTable/CreateCollectionOfferFlowTable.fragment"
import { CreateCollectionOfferTimeline_collectionFragment } from "../CreateCollectionOfferTimeline/CreateCollectionOfferTimeline.fragment"

export const CreateCollectionOfferFlowReview_collectionFragment = graphql(
  `
    fragment CreateCollectionOfferReview_collection on Collection {
      ...CreateCollectionOfferTimeline_collection
      ...constructCollectionOffer_collection
      ...CreateCollectionOfferFlowTable
      ...CreateOrdersSummary
      chain {
        identifier
        nativeCurrency {
          address
        }
        offerCurrency {
          address
          symbol
        }
      }
    }
  `,
  [
    constructCollectionOffer_collectionFragment,
    CreateCollectionOfferTimeline_collectionFragment,
    CreateCollectionOfferFlowTableFragment,
    CreateOrdersSummaryFragment,
  ],
)
